export const ALL_USERS = 'All users';
export const ALL_DEVICES = 'All devices';
export const ALL_LOCATIONS = 'All locations';
